/* gb-home.js (Gift Basket Delivery, 15 Sep 2026): the little behaviour the homepage sections need.
   Everything renders server-side; this file only adds arrows to native scroll rows, switches product tabs,
   and turns the gift finder's three selects into one destination URL. Loaded with defer by every gb-* section
   (same src, so the browser fetches it once); the guard below makes repeated executions a no-op.
   Re-runs on Shopify theme editor events so sections keep working while Nick edits them. */
(function () {
  if (window.gbHome) { window.gbHome.init(); return; }
  var gbHome = { init: init };
  window.gbHome = gbHome;

  function init(root) {
    root = root || document;
    each(root.querySelectorAll('[data-gbh-scroller]:not([data-gbh-ready])'), scroller);
    each(root.querySelectorAll('[data-gbh-tabs]:not([data-gbh-ready])'), tabs);
    each(root.querySelectorAll('[data-gbh-finder]:not([data-gbh-ready])'), finder);
  }
  function each(list, fn) { for (var i = 0; i < list.length; i++) fn(list[i]); }

  /* scroll row with prev/next arrows */
  function scroller(el) {
    el.setAttribute('data-gbh-ready', '1');
    var track = el.querySelector('[data-gbh-track]');
    var prev = el.querySelector('[data-gbh-prev]');
    var next = el.querySelector('[data-gbh-next]');
    if (!track) return;
    function step() { var item = track.firstElementChild; return item ? item.getBoundingClientRect().width + 16 : track.clientWidth * 0.8; }
    function update() {
      var scrollable = track.scrollWidth > track.clientWidth + 4;
      el.classList.toggle('is-scrollable', scrollable);
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
    }
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step() * 2, behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step() * 2, behavior: 'smooth' }); });
    track.addEventListener('scroll', throttle(update, 80), { passive: true });
    window.addEventListener('resize', throttle(update, 150));
    update();
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(update);
  }

  /* product tabs */
  function tabs(el) {
    el.setAttribute('data-gbh-ready', '1');
    var buttons = el.querySelectorAll('[role="tab"]');
    var panels = el.querySelectorAll('[role="tabpanel"]');
    function select(id) {
      each(buttons, function (b) { var on = b.getAttribute('aria-controls') === id; b.setAttribute('aria-selected', on ? 'true' : 'false'); b.tabIndex = on ? 0 : -1; });
      each(panels, function (p) { p.hidden = p.id !== id; });
      each(el.querySelectorAll('[data-gbh-scroller]'), function (s) { s.removeAttribute('data-gbh-ready'); scroller(s); });
    }
    each(buttons, function (b, i) {
      b.addEventListener('click', function () { select(b.getAttribute('aria-controls')); });
      b.addEventListener('keydown', function (e) {
        var idx = Array.prototype.indexOf.call(buttons, b), n = buttons.length, to = null;
        if (e.key === 'ArrowRight') to = buttons[(idx + 1) % n];
        if (e.key === 'ArrowLeft') to = buttons[(idx - 1 + n) % n];
        if (to) { e.preventDefault(); to.focus(); select(to.getAttribute('aria-controls')); }
      });
    });
  }

  /* gift finder: occasion or recipient picks the collection, price adds a filter */
  function finder(form) {
    form.setAttribute('data-gbh-ready', '1');
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var occasion = form.querySelector('[name="occasion"]');
      var recipient = form.querySelector('[name="recipient"]');
      var price = form.querySelector('[name="price"]');
      var url = (occasion && occasion.value) || (recipient && recipient.value) || form.getAttribute('data-gbh-fallback') || '/collections/all';
      var params = [];
      if (price && price.value) {
        var range = price.value.split('-');
        if (range[0]) params.push('filter.v.price.gte=' + encodeURIComponent(range[0]));
        if (range[1]) params.push('filter.v.price.lte=' + encodeURIComponent(range[1]));
      }
      if (params.length) url += (url.indexOf('?') > -1 ? '&' : '?') + params.join('&');
      window.location.assign(url);
    });
  }

  function throttle(fn, wait) { var t = 0; return function () { var now = Date.now(); if (now - t > wait) { t = now; fn(); } else { clearTimeout(fn._t); fn._t = setTimeout(fn, wait); } }; }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var tab = e.target && e.target.closest && e.target.closest('[role="tabpanel"]');
    if (tab) { var btn = document.querySelector('[aria-controls="' + tab.id + '"]'); if (btn) btn.click(); }
  });
})();
